import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getConflictRolePermissions = async (token, municipality_id, params) => {
  const url = `municipalities/${municipality_id}/conflicts/${params.conflict_id}/roles/${params.role_id}/permissions`
  const data = await apiGet({ url, token, params })
  return data
}

export function useConflictRolePermissions({ params, options = {} }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  const queryFn = () =>
    getConflictRolePermissions(token, municipality_id, params)
  const queryKey = ['conflictRolePermissions', params]
  return useQuery(queryKey, queryFn, { ...options })
}
